var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-a-link"},[_c('Input',{attrs:{"readonly":_vm.readonly,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"clearable":_vm.clearable},model:{value:(_vm.alink),callback:function ($$v) {_vm.alink=$$v},expression:"alink"}}),(_vm.msg)?_c('div',{staticClass:"c-col-msg"},[_c('span',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }